import axios from "../lib/axios";

export const createSubscription = async (data) => {
  try {
    const response = await axios.post("/subscriptions", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create subscription"
    );
  }
};

export const getAllSubscriptions = async () => {
  try {
    const response = await axios.get("/subscriptions");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch subscriptions"
    );
  }
};
